import { api } from '@/api'

export const getImageDownloadUrl = async (fileName: string) =>
  await api.get(`uploads/${fileName}`).json<{
    downloadUrl: string
  }>()
